import { useParams } from 'react-router-dom';
import SchemaOrg, { buildBreadcrumbSchema } from '@/components/feature/SchemaOrg';
import { categories } from '@/mocks/home';
import CategoryContent from './components/CategoryContent';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const activeCategory = categories.find((c) => c.slug === slug);

  return (
    <>
      <SchemaOrg type="WebPage" data={{
        name: `${activeCategory?.name || '分类'} - 凪光在线观看`,
        url: `https://subtitlesjp.github.io/category/${slug}`,
        breadcrumb: { '@type': 'BreadcrumbList', ...buildBreadcrumbSchema([
          { name: '首页', url: '/' },
          { name: activeCategory?.name || '分类' },
        ]) },
      }} />
      <SchemaOrg type="BreadcrumbList" data={buildBreadcrumbSchema([
        { name: '首页', url: '/' },
        { name: activeCategory?.name || '分类' },
      ])} />
      <CategoryContent />
    </>
  );
}